import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { LocalStorageService } from '../services/local-storage.service';
import { TokenValidationService } from '../services/token-validation.service';

@Injectable({
  providedIn: 'root',
})
export class LoginTokenGuard implements CanActivate {
  private localStorageService = inject(LocalStorageService);
  private tokenValidationService = inject(TokenValidationService);
  private router = inject(Router);

  canActivate(): boolean {
    const token = this.localStorageService.getItem('token');

    if (this.tokenValidationService.isTokenValid(token)) {
      // Redirect to home if valid token exists
      this.router.navigate(['/']);
    } else if (token) {
      // Clear invalid/expired token
      this.localStorageService.clear();
    }

    // Always allow navigation to continue (to login page)
    return true;
  }
}
